/** Что мы знаем о переписке, из которой звонят, в момент решения «звонить или молчать». */
export type IncomingRingContext = {
  /** Общий переключатель звуков приложения. */
  soundEnabled: boolean;
  /** Заглушена ли переписка, из которой пришёл звонок. Намеренно не влияет — см. ниже. */
  chatMuted: boolean;
};

/**
 * Звонить ли на входящий звонок.
 *
 * Правило вынесено отдельно, потому что его уже однажды поменяли молча: 11.08.2026 в условие
 * добавили заглушение переписки, и заглушивший перестал слышать звонки от этого человека вовсе —
 * на телефоне гасилось ещё и системное уведомление, то есть звонок пропадал целиком, без следа.
 *
 * Так делать нельзя. Заглушение — про сообщения: непрочитанное дождётся, его видно в списке и в
 * счётчике, и тишина ничего не отнимает. Звонок не дожидается: его либо слышно сейчас, либо
 * разговора не было. Ровно так устроен Telegram, и ровно этого ждёт человек, заглушивший
 * болтливую переписку: «не дёргай меня сообщениями», а не «я для тебя недоступен».
 *
 * Прекратить звонки от кого-то можно блокировкой — и она уже работает на сервере: звонок в
 * заблокированную пару не начинается (`user.blocked.peer`), а блокировка во время разговора его
 * обрывает.
 *
 * `chatMuted` в контексте остаётся намеренно: правило должно читаться целиком, вместе с тем, что
 * оно осознанно игнорирует, — иначе следующая правка снова добавит мьют в условие.
 */
export const shouldRingIncomingCall = (context: IncomingRingContext) => context.soundEnabled;
